/** @format */

import React from 'react';
import Card from 'react-bootstrap/Card';
import { EqualHeightElement } from 'react-equal-height';
import getPropertyTypeTranslation from '../../../../utils/getPropertyTypeTranslation';
import Flag from 'components/FlagComponent';
import { PropertyTypes } from 'utils/propertyObjectHelper';
import { buildAddress } from 'utils/addressHelper';
import BlankImage from 'assets/images/images/no-object-image.png';
import { displayAsPrice } from 'utils/format';

import './styles.scss';

export default function ImageCard(props) {
  const {
    type,
    //price, not used anymore
    startingPrice,
    finalPrice,
    location,
    bedrooms,
    bathrooms,
    dimensions,
    currency,
    // status,
    imageUrl,
    onComplete,
    isMobile,
    translation,
    countryCode,
    noOfRooms,
    monthlyFee,
    address,
    extra
  } = props;

  const PropertySummarySection = () => {
    const PropertyInfo = ({ value = null, text = '', className = false }) => (
      <span className={`icon-strip-text ${className ? className : ''}`}>
        {value ? value : 'N/A'}
        <span className='label-text'>{text}</span>
      </span>
    );

    if ([PropertyTypes.HousingCooperative].includes(type)) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container three-items'>
            <PropertyInfo
              value={noOfRooms}
              text='rum'
              className='no-of-rooms'
            />
            <PropertyInfo value={monthlyFee} text='kr/mån' />

            <PropertyInfo value={dimensions} text='Kvm' className='area-size' />
          </div>
        </div>
      );
    } else if (
      [PropertyTypes.House, PropertyTypes.Condominium].includes(type)
    ) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container two-items'>
            <PropertyInfo
              value={noOfRooms}
              text='rum'
              className='no-of-rooms'
            />

            <PropertyInfo value={dimensions} text='Kvm' className='area-size' />
          </div>
        </div>
      );
    } else if (
      [PropertyTypes.Plot, PropertyTypes.CommercialProperty].includes(type)
    ) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container two-items'>
            <PropertyInfo value={dimensions} text='Kvm' className='area-size' />
          </div>
        </div>
      );
    } else {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container three-items'>
            <PropertyInfo
              value={bedrooms}
              text='sovrum'
              className='no-of-bed-rooms'
            />
            <PropertyInfo value={bathrooms} text='badrum' />

            <PropertyInfo value={dimensions} text='Kvm' className='area-size' />
          </div>
        </div>
      );
    }
  };

  const AddressSection = () => {
    const builtAddress = buildAddress({
      streetAddress: address.streetAddress,
      municipality: address?.municipality,
      city: address?.city,
      estateType: type,
      objectAddressObj: address
    });

    if (builtAddress) {
      return (
        <span className='listing-type address text2r'>{builtAddress}</span>
      );
    }

    return (
      <span
        style={{
          display: 'block',
          height: '20px'
        }}
      />
    );
  };

  const PriceSection = () => {
    const getDisplayPrice = () => {
      if (finalPrice > 0) {
        return finalPrice;
      } else {
        return startingPrice || 0;
      }
    };

    const displayPrice = displayAsPrice(getDisplayPrice());

    const displayCurrency = (() => {
      const { currency: currencyName } = extra?.price || {};
      if (currencyName && currencyName !== 'SEK') {
        return currencyName;
      } else {
        return currency;
      }
    })();

    return (
      <h3 className='listing-price'>{displayPrice + ' ' + displayCurrency}</h3>
    );
  };

  const ObjectStatusIndicator = () => {
    if (extra?.status?.id === '10' || extra?.status?.id === '4') {
      return (
        <p className='listing-box-sold-tag text3m'>
          {translation?.property_status?.sold?.text}
        </p>
      );
    } else if (extra?.status?.id === '11' || extra?.advertise?.showAsComming) {
      return (
        <p className='listing-box-upcoming-tag text3m'>
          {translation?.property_status?.upcoming?.text}
        </p>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Card className='listing-box'>
      {!isMobile ? (
        <div className='listing-box-img-container'>
          <Card.Img
            variant='top'
            className='listing-box-img'
            onLoad={onComplete}
            src={imageUrl.length === 0 ? BlankImage : imageUrl}
          />

          <ObjectStatusIndicator />
        </div>
      ) : (
        <EqualHeightElement>
          <div className='listing-box-img-container'>
            <Card.Img
              variant='top'
              className='listing-box-img'
              onLoad={onComplete}
              src={imageUrl.length === 0 ? BlankImage : imageUrl}
            />

            <ObjectStatusIndicator />
          </div>
        </EqualHeightElement>
      )}

      <Card.Body>
        <div className='heading-flag-section'>
          <p className='listing-type  text2r'>
            {getPropertyTypeTranslation(type, translation?.propertyType)}
          </p>
          <Flag countryCode={countryCode || 'SE'} />
        </div>
        <p className='listing-location '>
          {typeof location === 'string' && location !== ''
            ? location.length > 15
              ? `${location.substring(0, 15)}...`
              : location
            : '\u00A0'}
        </p>
        <AddressSection />

        <PriceSection />

        <PropertySummarySection />
      </Card.Body>
    </Card>
  );
}
